import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import Widget from "@components/Widget/Widget";
import FlightsPaxCombinedChart from "@charts/apexcharts/FlightMovements/FlightsPaxCombinedChart";
export const FlightMovementsPaxCombinedBarChartWidget = ({ title }) => {
    const { t } = useTranslation();
    const mainTitle = t(title);
    return (_jsxs(Widget.Container, { children: [_jsx(_Fragment, { children: _jsx(Widget.Header, { title: mainTitle, subtitleVisibility: "none" }) }), _jsx(Widget.Body, { children: _jsx(FlightsPaxCombinedChart, {}) })] }));
};
FlightMovementsPaxCombinedBarChartWidget.displayName = "FlightMovementsPaxCombinedBarChartWidget";
